import {Modal, Button, notification} from "antd";
import React, {useState} from "react";
import {useInView} from "react-intersection-observer";
import {termsConfig} from "../../../config/terms.config";
import {userServices} from "../../../services";
import i18n from "../../../i18n";

export default function ShowAgreementMaterialServices({isShow, setIsShow}) {
  const [loading, setLoading] = useState(false);

  const [endPage, inViewEndPage] = useInView({
    threshold: 0.2,
  });

  const submitBtnStyle = {
    width: "200px",
    height: "43px",
    background: "#1CAA53",
    position: "static",
    borderRadius: "10px",
    color: "white",
    borderColor: "transparent",
  };

  const handleSubmit = () => {
    setLoading(true);

    userServices.readAgreementMaterialServices()
      .then(() => userServices.updateUserInfo())
      .then(() => {
        setIsShow(false);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.error'),
          description: err,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title={termsConfig.agreement_material_services_title}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window modal-window--terms"
      apgn={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={
        <Button
          htmlType="submit"
          key="submit"
          type="primary"
          style={submitBtnStyle}
          onClick={handleSubmit}
          disabled={!inViewEndPage || loading}
          loading={loading}
        >
          {i18n.t('main.buttons.agree')}
        </Button>
      }
    >
      {termsConfig.agreement_material_services_text}
      <div><p ref={endPage}>&nbsp;</p></div>
    </Modal>
  );
}
